<template>

  <modal
    name="edit-work-day"
    class="modal--translation"
    v-cloak height="auto"
    :scrollable="true"
    :adaptive="true"
    :pivot-y="0.25"
    @before-open="beforeOpen"
  >
    <h5 class="modal-title">{{ title }} - <span class="selected-date">{{
        date ? date.format('DD. MM. YYYY') : null
      }}</span></h5>

    <button @click="closeModal()" type="button" class="close close-modal">
      <i class="fal fa-fw fa-times"></i>
    </button>

    <work-day-embed-form
      ref="workDayEmbedForm"
      :work-interval-types="workIntervalTypes"
      :default-interval="defaultInterval"
      :worked-holidays="workedHolidays"
      :default-form-data="defaultFormData"
      :daily-working-fund="dailyWorkingFund"
      :contract-settings="contractSettings"
      :trans="trans"
    />

    <b-alert
      v-if="intervalIsOverlaid"
      show variant="danger"
      class="col-12 d-flex align-items-center mt-3"
    >
      <i class="fal fa-exclamation-circle fa-2x mr-2"></i>
      <strong>
        {{ trans.form.overlay_intervals }}
      </strong>
    </b-alert>

    <b-alert
      v-if="!nvpHolidayState.state"
      show
      :variant="nvpHolidayState.variant"
      class="col-12 px-3 mt-3"
    >
      <strong v-if="nvpHolidayState.variant == 'danger'">
        {{ trans.form.more_nvp_hours + ': ' + nvpHolidayState.hours + ' ' + trans.hours }}
      </strong>
      <strong v-else class="text-dark">
        {{ trans.form.less_nvp_hours }}
      </strong>
    </b-alert>

    <div class="text-center" style="margin-top: 30px;">
      <button
        @click="submitForm()"
        type="submit"
        class="btn btn-primary"
        :disabled="submiting"
      >
        <strong>{{ trans.saveBtn }}</strong>
      </button>
    </div>
  </modal>
</template>


<script>
import {cloneDeep} from 'lodash';

const userLanguage = document.documentElement.lang;

export default {
  name: 'work-day-modal-form',
  data: function () {
    return {
      url: null,
      title: this.trans.form.title_add,
      date: null,
      defaultInterval: {
        work_interval_type: 'work',
        compensation_holiday: null,
        compensated_by: null,
        from: moment().hours(8).minutes(0).seconds(0).format('kk:mm'),
        to: moment().hours(12).minutes(0).seconds(0).format('kk:mm')
      },
      intervalIsOverlaid: false,
      defaultFormData: {},
      nvpHolidayState: {state: true, variant: 'danger', hours: 0},
      isWarnedLessHoursNvpHoliday: false,
      submiting: false
    }
  },

  props: {
    'baseUrl': {
      type: String
    },
    'workIntervalTypes': {
      type: Array
    },
    'workedHolidays': {
      type: Array
    },
    'contractSettings': {
      type: Object
    },
    'trans': {
      type: Object
    },
    'dailyWorkingFund': {
      type: Number,
      required: false,
      default: () => {
        return 7;
      }
    }
  },

  created() {
  },

  methods: {
    beforeOpen(event) {
      const day = event.params.day;

      let form = {
        intervals: []
      };

      this.date = moment(day.date);
      this.url = this.baseUrl + "/" + this.date.format('YYYY') + "/" + this.date.format('MM') + "/" + this.date.format('DD');

      if (day.workDay && day.workDay.intervals && day.workDay.intervals.length > 0) {
        this.title = this.trans.form.title_edit;

        form.intervals = day.workDay.intervals.map((interval) => {
          let compensationHoliday = this.workedHolidays.find(x => x.compensated_by == day.workDay.id);

          return {
            ...this.defaultInterval,
            from: moment(interval.from).format('kk:mm'),
            to: moment(interval.to).format('kk:mm'),
            work_interval_type: interval.work_interval_type,
            interval_length: interval.interval_length,
            compensation_holiday: (compensationHoliday ? compensationHoliday.id : null)
          };
        });
      } else {
        this.title = this.trans.form.title_add;
        form.intervals = cloneDeep([this.defaultInterval]);
      }

      this.defaultFormData = form;

      this.nvpHolidayState = {state: true, variant: 'danger', hours: 0};
      this.isWarnedLessHoursNvpHoliday = false;
    },

    submitForm() {
      const _this = this;
      const data = this.$refs.workDayEmbedForm.getData();

      this.$emit('setmodalloadingdate', this.date);

      // validate intervals
      if (this.$refs.workDayEmbedForm.validateIntervals()) {
        this.intervalIsOverlaid = true;
        return;
      } else this.intervalIsOverlaid = false;

      // validate nvp holidays state
      this.nvpHolidayState = this.$refs.workDayEmbedForm.getNvpHolidayState();
      if (!this.nvpHolidayState.state) {
        if (this.nvpHolidayState.variant == "warning") {
          if (!this.isWarnedLessHoursNvpHoliday) {
            this.isWarnedLessHoursNvpHoliday = true;
            this.$emit('setmodalloadingdate', null);
            return;
          }
        } else {
          this.$emit('setmodalloadingdate', null);
          return;
        }
      }

      this.submiting = true;
      
      // send request
      axios.post(this.url, data).then(function (response) {
        return _this.onSuccess(response);
      }).catch(function (errors) {
        return _this.onFail(errors);
      }).finally(() => this.submiting = false);
    },

    onSuccess(response) {
      this.closeModal();

      this.$emit('setmodalloadingdate', null);
      this.$emit('refreshattendance');
      this.$emit('refreshcalendar');
      this.$emit('refreshworkedholidays');
      this.$emit('refreshbalances');

      this.isWarnedLessHoursNvpHoliday = false;

      this.$notify({
        type: 'success',
        title: 'Success!',
        text: response.data.message ? response.data.message : 'Item successfully created.'
      });
    },

    onFail(error) {
      this.closeModal();

      this.$emit('setmodalloadingdate', null);
      this.$emit('refreshattendance');
      this.$emit('refreshcalendar');
      this.$emit('refreshworkedholidays');
      this.$emit('refreshbalances');

      this.isWarnedLessHoursNvpHoliday = false;

      let errorMsg = error.response.data.message ? error.response.data.message : 'An error has occured.';

      if (error.response.data.errors) {
        errorMsg += Object.keys(error.response.data.errors).map(function (key) {
          return '<br />' + error.response.data.errors[key][0];
        });
      }

      this.$notify({type: 'error', title: 'Error!', text: errorMsg});
    },

    closeModal() {
      this.$modal.hide('edit-work-day');
    },
  }

};
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/modals/WorkDayModalForm.vue